import { render, staticRenderFns } from "./CheckCode.vue?vue&type=template&id=6c45026e&scoped=true&"
import script from "./CheckCode.vue?vue&type=script&lang=js&"
export * from "./CheckCode.vue?vue&type=script&lang=js&"
import style0 from "./_checkCode.scss?vue&type=style&index=0&id=6c45026e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45026e",
  null
  
)

export default component.exports